import { Pipe, PipeTransform } from '@angular/core';
import { StaleProperty } from '../state-management/undo-redo';

@Pipe({
    name: 'stale',
    standalone: false
})
export class StalePipe implements PipeTransform {

    transform(differences: StaleProperty[], path: string | string[]): boolean {
        if(!Array.isArray(differences)){
            return false;
        }

        let pathArray = path && Array.isArray(path) ? [...path] : [path];

        // Changes between nullable values can be ignored.
        // I.e. from undefined to empty string is visually not a change
        return differences.some(diff => pathArray.includes(diff.path) && (diff.newValue || diff.oldValue));
    }

}
